import React from 'react';
import { BookOpen, Calendar, Users, User, ArrowRight } from 'lucide-react';

const HomepageHub = () => {
    const sections = [
        {
            id: 'kniha',
            title: 'Kniha: Renta bez dátumu spotreby',
            subtitle: 'Praktický manuál k finančnej slobode',
            description: 'Kompletný systém budovania majetku, ktorý publikujem online. Začnite čítať ešte dnes.',
            image: '/kniha_cover.jpeg',
            link: '/kniha',
            cta: 'Vstúpiť do knižnice',
            color: 'bg-brand-orange',
            icon: BookOpen
        },
        {
            id: 'spolupraca',
            title: 'Spolupráca & Wealth Management',
            subtitle: 'Dostaňte svoj majetok pod kontrolu',
            description: 'Individuálne riešenia pre podnikateľov a manažérov. Zmeňte chaos na poriadok.',
            image: '/spoluprace_mentorvibe.jpeg',
            link: '/spolupraca',
            cta: 'Dohodnúť schôdzku',
            color: 'bg-brand-dark-blue',
            icon: Calendar
        },
        {
            id: 'kariera',
            title: 'Kariéra v mojom tíme',
            subtitle: 'Staňte sa hviezdou wealth manažmentu',
            description: 'Hľadáme partnerov, ktorí nechcú predávať produkty, ale budovať hodnotu.',
            image: '/kariera_hero.jpeg',
            link: '/kariera',
            cta: 'Pridať sa k nám',
            color: 'bg-green-600',
            icon: Users
        },
        {
            id: 'pribeh',
            title: 'Príbeh Peťa Slobodu',
            subtitle: 'Od hokeja k architektúre majetku',
            description: 'Moje hodnoty, moje pády a cesta, ktorá ma naučila disciplíne a pokoju.',
            image: '/pribeh_hero.jpeg',
            link: '/o-mne',
            cta: 'Môj osobný príbeh',
            color: 'bg-brand-baby-blue',
            icon: User
        }
    ];

    return (
        <section className="bg-brand-dark-blue py-6 lg:py-20 min-h-screen overflow-x-clip">
            <div className="container mx-auto px-4 sm:px-5 max-w-full min-w-0">
                <div className="text-center mb-12 max-w-2xl mx-auto px-1">
                    <h1 className="text-2xl min-[400px]:text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-white mb-4 leading-tight break-words">
                        Vstúpte do sveta <span className="text-brand-orange">systémových financií</span>
                    </h1>
                    <p className="text-gray-400 text-base sm:text-lg">
                        Vyberte si cestu, ktorou sa chcete dnes vydať.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-10 max-w-6xl mx-auto min-w-0">
                    {sections.map((section) => (
                        <a
                            key={section.id}
                            href={section.link}
                            className="group relative h-[min(450px,85vh)] md:h-[550px] rounded-[2rem] sm:rounded-[2.5rem] overflow-hidden shadow-2xl transition-all duration-500 hover:scale-[1.01]"
                        >
                            {/* Background Image */}
                            <div className="absolute inset-0">
                                <img
                                    src={section.image}
                                    alt={section.title}
                                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-brand-dark-blue via-brand-dark-blue/70 to-brand-dark-blue/20" />
                            </div>

                            {/* Content */}
                            <div className="relative h-full flex flex-col justify-end p-6 sm:p-8 lg:p-12">
                                <div className={`${section.color} w-12 h-12 rounded-xl flex items-center justify-center text-white mb-6 shadow-lg group-hover:rotate-3 transition-transform`}>
                                    <section.icon size={24} />
                                </div>
                                <p className="text-brand-orange font-bold uppercase tracking-widest text-[10px] mb-2">
                                    {section.subtitle}
                                </p>
                                <h2 className="text-2xl lg:text-3xl font-heading font-bold text-white mb-3">
                                    {section.title}
                                </h2>
                                <p className="text-gray-300 text-sm mb-6 max-w-xs line-clamp-2">
                                    {section.description}
                                </p>
                                <div className="flex items-center text-white font-bold text-base group-hover:gap-2 transition-all">
                                    <span>{section.cta}</span>
                                    <ArrowRight size={18} className="ml-2 text-brand-orange" />
                                </div>
                            </div>
                        </a>
                    ))}
                </div>

                <div className="mt-16 text-center">
                    <p className="text-gray-500 text-xs uppercase tracking-widest mb-6 font-medium">Spolupráca pre firmy</p>
                    <a
                        href="/firmy"
                        className="inline-flex items-center gap-2 text-gray-400 hover:text-white transition-colors border-b border-gray-700 pb-1 text-sm"
                    >
                        Hľadáte riešenia pre váš tím? Pozrite si B2B sekciu <ArrowRight size={14} />
                    </a>
                </div>
            </div>
        </section>
    );
};

export default HomepageHub;
